/**
 * Chrome-free wrapper for the printed documents (§12). A sticky toolbar (never
 * printed — see print.css) carries Print + Close and any per-document controls
 * (e.g. the picking-list layout switch). The page itself is the `.doc` A4 sheet
 * the caller renders as children.
 */
import type { ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../../components/ui/index.js";

export function PrintFrame({
  title,
  actions,
  children,
}: {
  title: string;
  /** Per-document controls shown left of Print (layout switch, reprint, …). */
  actions?: ReactNode;
  children: ReactNode;
}) {
  const navigate = useNavigate();
  const close = () => {
    // Opened in a new tab → close it; navigated in-app → go back.
    if (window.history.length > 1) navigate(-1);
    else window.close();
  };
  return (
    <div className="doc-screen">
      <div className="doc-toolbar">
        <span className="doc-toolbar__title">{title}</span>
        {actions}
        <span className="doc-toolbar__spacer" />
        <Button size="sm" variant="primary" icon="printer" onClick={() => window.print()}>
          Print
        </Button>
        <Button size="sm" variant="ghost" icon="x" onClick={close}>
          Close
        </Button>
      </div>
      {children}
    </div>
  );
}
